import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import 'core-js/es/array/find';
import React, { useState, useEffect, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { usePopper } from 'react-popper';
import maxSizeModifier from 'popper-max-size-modifier';
import bemCnFast from '@webteam/bem-cn-fast';
import { withTheme, LayeringConsumer, LayeringProvider } from '@webteam/ui-contexts';
import ReactDOM from 'react-dom';
import localNames from './index.pcss.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }
var bemCn = bemCnFast('wt-dropdown', localNames);
var ITEM_HEIGHT_BY_SIZE = {
  xs: 24,
  s: 36,
  m: 48
};
var OFFSET_FROM_TRIGGER_BY_SIZE = {
  xs: 4,
  s: 6,
  m: 12
};
var sameWidthModifier = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: function fn(_ref) {
    var state = _ref.state,
        _ref$options = _ref.options;
    _ref$options = _ref$options === void 0 ? {} : _ref$options;
    var widthEqualsTriggers = _ref$options.widthEqualsTriggers,
        minWidth = _ref$options.minWidth;
    state.styles.popper.minWidth = "".concat(getMinWidth(widthEqualsTriggers, minWidth, state.rects.reference.width), "px");
  },
  effect: function effect(_ref2) {
    var state = _ref2.state,
        _ref2$options = _ref2.options;
    _ref2$options = _ref2$options === void 0 ? {} : _ref2$options;
    var widthEqualsTriggers = _ref2$options.widthEqualsTriggers,
        minWidth = _ref2$options.minWidth;
    state.elements.popper.style.minWidth = "".concat(getMinWidth(widthEqualsTriggers, minWidth, state.elements.reference.offsetWidth), "px");
  }
};
var applyMaxSize = {
  name: 'applyMaxSize',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['maxSize'],
  // eslint-disable-next-line complexity
  fn: function fn(_ref3) {
    var state = _ref3.state,
        _ref3$options = _ref3.options,
        itemHeight = _ref3$options.itemHeight,
        maxHeight = _ref3$options.maxHeight;
    var height = state.modifiersData.maxSize.height;
    var heightLeft = height;
    var resultHeightString;

    if (maxHeight > heightLeft && heightLeft > itemHeight) {
      resultHeightString = "".concat(heightLeft, "px");

      if (state.styles.popper.maxHeight !== resultHeightString && state.rects.popper.height >= heightLeft) {
        // change popper height for detectOverflow util to force flip modifier to find better placement
        state.rects.popper.height = heightLeft;
        state.reset = true;
      }
    } else if (heightLeft < itemHeight) {
      resultHeightString = "".concat(itemHeight, "px");

      if (state.styles.popper.maxHeight !== resultHeightString && state.rects.popper.height >= itemHeight) {
        // change popper height for detectOverflow util to force flip modifier to find better placement
        state.rects.popper.height = itemHeight;
        state.reset = true;
      }
    } else {
      resultHeightString = "".concat(maxHeight, "px");
    }

    state.styles.popper.maxHeight = resultHeightString;
  }
};

var Portal = function Portal(_ref4) {
  var children = _ref4.children,
      _ref4$target = _ref4.target,
      target = _ref4$target === void 0 ? document.body : _ref4$target;
  return ReactDOM.createPortal(children, target);
};
/* eslint-disable react/prop-types */


function DropdownRender(_ref5, externalRef) {
  var children = _ref5.children,
      trigger = _ref5.trigger,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 'm' : _ref5$size,
      _ref5$theme = _ref5.theme,
      theme = _ref5$theme === void 0 ? 'light' : _ref5$theme,
      _ref5$borderHardness = _ref5.borderHardness,
      borderHardness = _ref5$borderHardness === void 0 ? 'average' : _ref5$borderHardness,
      _ref5$isOpen = _ref5.isOpen,
      isOpen = _ref5$isOpen === void 0 ? false : _ref5$isOpen,
      _ref5$placement = _ref5.placement,
      placement = _ref5$placement === void 0 ? 'bottom-start' : _ref5$placement,
      _ref5$onRequestClose = _ref5.onRequestClose,
      onRequestClose = _ref5$onRequestClose === void 0 ? function () {} : _ref5$onRequestClose,
      _ref5$widthEqualsTrig = _ref5.widthEqualsTriggers,
      widthEqualsTriggers = _ref5$widthEqualsTrig === void 0 ? false : _ref5$widthEqualsTrig,
      minWidth = _ref5.minWidth,
      maxWidth = _ref5.maxWidth,
      _ref5$maxVisibleItems = _ref5.maxVisibleItems,
      maxVisibleItems = _ref5$maxVisibleItems === void 0 ? 5 : _ref5$maxVisibleItems;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      popperRef = _useState2[0],
      setPopperRef = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      triggerRef = _useState4[0],
      setTriggerRef = _useState4[1];

  var handleDocumentClick = function handleDocumentClick(e) {
    if (!popperRef || e.target === popperRef || popperRef.contains(e.target)) {
      return;
    }

    if (!triggerRef || e.target === triggerRef || triggerRef.contains(e.target)) {
      return;
    }

    onRequestClose();
  }; // eslint-disable-next-line consistent-return


  useEffect(function () {
    if (isOpen && popperRef) {
      document.addEventListener('click', handleDocumentClick, true);
      return function () {
        return document.removeEventListener('click', handleDocumentClick, true);
      };
    }
  }, [handleDocumentClick, isOpen, popperRef]);
  var itemHeight = ITEM_HEIGHT_BY_SIZE[size]; // half of item added to show that there is more items even if scroll bar hidden

  var maxHeight = (Math.ceil(maxVisibleItems) + 0.5) * itemHeight;

  var _usePopper = usePopper(triggerRef, popperRef, {
    placement: placement,
    modifiers: [{
      name: 'hide',
      enabled: false
    }, {
      name: 'flip',
      enabled: true
    }, {
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, OFFSET_FROM_TRIGGER_BY_SIZE[size]]
      }
    }, maxSizeModifier, _objectSpread(_objectSpread({}, applyMaxSize), {}, {
      options: {
        maxHeight: maxHeight,
        itemHeight: itemHeight
      }
    }), _objectSpread(_objectSpread({}, sameWidthModifier), {}, {
      options: {
        widthEqualsTriggers: widthEqualsTriggers,
        minWidth: minWidth
      }
    })]
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      forceUpdate = _usePopper.forceUpdate;

  var triggerRenderer = typeof trigger === 'function' ? trigger({
    ref: setTriggerRef
  }) : React.createElement("span", {
    "data-test": "dropdown-trigger",
    className: bemCn('trigger-wrapper'),
    ref: setTriggerRef
  }, trigger);
  useImperativeHandle(externalRef, function () {
    return {
      scheduleUpdate: function scheduleUpdate() {
        if (forceUpdate) {
          forceUpdate();
        }
      }
    };
  });
  /* eslint-disable react/jsx-no-bind */

  return React.createElement(React.Fragment, null, triggerRenderer, isOpen && React.createElement(Portal, null, React.createElement(LayeringConsumer, null, function (_ref6) {
    var dropdownZIndex = _ref6.dropdownZIndex;
    return React.createElement("div", _extends({
      ref: setPopperRef,
      style: _objectSpread(_objectSpread({
        maxHeight: maxHeight
      }, styles.popper), {}, {
        maxWidth: getMaxWidth(widthEqualsTriggers, maxWidth),
        zIndex: dropdownZIndex
      }),
      className: bemCn({
        size: size,
        theme: theme,
        'border-hardness': borderHardness
      }),
      "data-test": "dropdown"
    }, attributes.popper), React.createElement(LayeringProvider, {
      baseLayer: 'dropdown'
    }, children));
  })));
}
/* eslint-enable react/prop-types */


var Dropdown = React.forwardRef(DropdownRender);
Dropdown.propTypes = {
  trigger: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func,
  size: PropTypes.oneOf(['m', 's', 'xs']),
  theme: PropTypes.oneOf(['light', 'dark']),
  borderHardness: PropTypes.oneOf(['average', 'pale']),
  placement: PropTypes.oneOf(['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']),

  /* @ignore */
  minWidth: PropTypes.any,

  /* @ignore */
  maxWidth: PropTypes.any,

  /* @ignore */
  maxVisibleItems: PropTypes.number
};
var dropdown = withTheme(Dropdown);

function getMaxWidth(widthEqualsTriggers, dropdownMaxWidth) {
  if (!dropdownMaxWidth) {
    return widthEqualsTriggers ? 'none' : undefined;
  } else {
    return dropdownMaxWidth;
  }
}

function getMinWidth(widthEqualsTriggers, dropdownMinWidth, referenceWidth) {
  if (typeof dropdownMinWidth === 'number' || typeof dropdownMinWidth === 'string' && dropdownMinWidth !== '') {
    return dropdownMinWidth;
  } else if (widthEqualsTriggers) {
    return referenceWidth;
  }

  return undefined; //rely on CSS by default
}

export { dropdown as default };
